import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart } from 'lucide-react';

export function Navbar() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  if (isAdminPage) {
    return null;
  }

  return (
    <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-sm z-50 px-4 py-3">
      <div className="max-w-6xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center gap-2">
          <Heart className="w-6 h-6 text-rose-500" />
          <span className="text-xl font-bold text-gray-900">WeddingWalliyan</span>
        </Link>
        <button 
          onClick={() => document.getElementById('waitlist-section')?.scrollIntoView({ behavior: 'smooth' })}
          className="px-4 py-2 bg-rose-500 text-white rounded-full hover:bg-rose-600 transition-colors"
        >
          Join Waitlist
        </button>
      </div>
    </nav>
  );
}